import { createSelector } from '@ngrx/store';
import { State } from '../reducers';

export const selectApplicationChainState = (state: State) => state.applicationChain;


export const getApplicationChain = createSelector(
    selectApplicationChainState,
    applicationChain => applicationChain.applications
);